import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PmOfferProjectState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: PmOfferProjectState = {
  data: [],
  isLoading: false,
  error: null,
};

const PmOfferProjectSlice = createSlice({
  name: 'pmOffer',
  initialState,
  reducers: {
    setPmOfferProjects: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setPmOfferProjectLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setPmOfferProjectError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setPmOfferProjects, setPmOfferProjectLoading, setPmOfferProjectError } = PmOfferProjectSlice.actions;

export default PmOfferProjectSlice.reducer;
